var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorials-grid flex flex-wrap justify-between"},[_vm._l((_vm.tutorials),function(tutorial){return [_c('TutorialCard',{key:tutorial.id,staticClass:"tutorial",attrs:{"tutorial":tutorial}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }